import { Button, Dialog, DialogTitle, DialogActions, TextField, Box } from '@mui/material';

interface Props {
  date: any;
}

const formatDateToPersian = (date: Date): string => {
  const formatter = new Intl.DateTimeFormat('fa-IR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  const parts = formatter.format(date);

  // تبدیل اعداد فارسی به انگلیسی
  const toEnglishDigits = (persianNumber: string): string =>
    persianNumber.replace(/[۰-۹]/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit).toString());

  // جدا کردن سال، ماه و روز و تبدیل به انگلیسی
  const [persianYear, persianMonth, persianDay] = parts.split('/');

  const year = toEnglishDigits(persianYear);
  const month = toEnglishDigits(persianMonth).padStart(2, '0');
  const day = toEnglishDigits(persianDay).padStart(2, '0');

  return `${year}/${month}/${day}`;
};

export const DateConverter: any = ({ date }: Props) => {
  if (!date) return ''; // بررسی مقدار null یا undefined

  const parsedDate1 = new Date(date);
  const parsedDate = new Date(parsedDate1.getUTCFullYear(), parsedDate1.getUTCMonth(), parsedDate1.getUTCDate());
 
  if (isNaN(parsedDate.getTime())) {
    return ''; // مقدار نامعتبر
  }
  const changeDateToDateFormat = date ? new Date(date) : null;
  if (!changeDateToDateFormat || isNaN(changeDateToDateFormat.getTime())) {
    return '';
  }

  const changeDateToLocale = formatDateToPersian(changeDateToDateFormat);

  return changeDateToLocale;
};
